import React from 'react';
import { CheckCircle2, XCircle, Info } from 'lucide-react';
import { cn } from '../../../lib/utils';

type Tone = 'success' | 'error' | 'info';

export interface TaskyToastProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: Tone;
  icon?: React.ReactNode;
}

const toneIcon: Record<Tone, React.ReactNode> = {
  success: <CheckCircle2 className="w-5 h-5 text-success" />,
  error: <XCircle className="w-5 h-5 text-destructive" />,
  info: <Info className="w-5 h-5 text-primary" />,
};

const toneBg: Record<Tone, string> = {
  success: 'bg-success/10',
  error: 'bg-destructive/10',
  info: 'bg-primary/10',
};

export const TaskyToast = React.forwardRef<HTMLDivElement, TaskyToastProps>(
  ({ className, tone = 'info', icon, children, ...rest }, ref) => (
    <div
      ref={ref}
      role="status"
      {...rest}
      className={cn(
        'rounded-tasky-md p-4 flex items-center gap-3 shadow-card animate-slide-in',
        toneBg[tone],
        className,
      )}
    >
      {icon ?? toneIcon[tone]}
      <span className="text-sm text-dark">{children}</span>
    </div>
  ),
);
TaskyToast.displayName = 'TaskyToast';
